import { useLocation, useNavigate } from 'react-router-dom';
import { HudRow } from './HudRow';
import { HudChip } from './HudChip';

/**
 * Sister-surface pill row for the tactics board HUD.
 *
 * The three planning surfaces a coach moves between — the training
 * Session, the Set-Piece library, and Match Day — sit as siblings of
 * the board itself. The pills let the coach jump straight to any of
 * them without going back through the brain bar; the pill for the
 * surface they're currently on reads active.
 */
const SURFACES = [
  { label: 'Session', route: '/sessions' },
  { label: 'Set Pieces', route: '/setpieces' },
  { label: 'Match Day', route: '/games' },
] as const;

export function SurfacePills() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <HudRow label="Plan">
      {SURFACES.map((s) => (
        <HudChip
          key={s.route}
          active={pathname === s.route || pathname.startsWith(`${s.route}/`)}
          ariaLabel={`Go to ${s.label}`}
          onClick={() => navigate(s.route)}
        >
          {s.label}
        </HudChip>
      ))}
    </HudRow>
  );
}
